import {
  RatingConfigurator,
  CommentConfigurator,
} from '@bingads-webui-campaign-react/survey-factory-tools';

export const CampaignOnboardingSurveyConfig = (options) => {
  const { i18n } = options;

  return {
    featureArea: 'CampaignOnboardingSurvey',
    style: {
      root: {
        maxWidth: 600,
      },
    },
    others: {
      isGlobalModalStyleEnabled: true,
      isThankYouPageEnabled: false,
      isUserInitiatedSurvey: true,
      isInPageMiddle: true,
      isModeless: false,
      isBlocking: true,
    },
    rating: {
      isRequired: true,
      Type: RatingConfigurator,
      key: 'rating',
      page: 0,
      position: 0,
      getTitle: () =>
        // option to text
        i18n.getString(_TL_('Why don\'t you want to use the new campaign creation experience?')),
      isVisible: () => true,
      options: [
        {
          key: '1',
          text: i18n.getString(_TL_('I can\'t find what I need.')),
          rating: 0.3,
        },
        {
          key: '2',
          text: i18n.getString(_TL_('I want more time to adapt to the new layout.')),
          rating: 0.6,
        },
        {
          key: '3',
          text: i18n.getString(_TL_('Other')),
          rating: 1.0,
        },
      ],
      data: {
      },
    },
    questions: [
      {
        isRequired: true,
        Type: CommentConfigurator,
        key: 'q1',
        page: 0,
        position: 1,
        getTitle: () => i18n.getString(_TL_('Tell us more')),
        isVisible: true,
        maxLength: 1024,
        data: {
        },
      },
    ],
  };
};
